import { render, staticRenderFns } from "./ParticipationBenefits.vue?vue&type=template&id=59c58357&scoped=true"
import script from "./ParticipationBenefits.vue?vue&type=script&lang=js"
export * from "./ParticipationBenefits.vue?vue&type=script&lang=js"
import style0 from "./ParticipationBenefits.vue?vue&type=style&index=0&id=59c58357&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c58357",
  null
  
)

export default component.exports